import CustomSelectGrouped from "../../../common/interactive/CustomSelectGrouped";
import CustomSelectGroupedMultiple from "../../../common/interactive/CustomSelectGroupedMultiple";
import { useState } from "react";

export default function GroupedOption({filtersValues, options, item, mainSelectAction, classes, isMultiple}) {    


    const [proccesedOptions, setProccessedoptions] = useState(options)
 
    return <div className={classes.row}>
        {!isMultiple && <CustomSelectGrouped preSelectedValue={filtersValues && filtersValues[item.key] && filtersValues[item.key]} optionsData={proccesedOptions} label={item.label} identifier={{type: item.key}} action={mainSelectAction}/>}
        {isMultiple && <CustomSelectGroupedMultiple preSelectedValue={filtersValues && filtersValues[item.key] && filtersValues[item.key].map(item => item)} optionsData={proccesedOptions} label={item.label} identifier={{type: item.key}} action={mainSelectAction}/>}
    </div>
}